import { render, staticRenderFns } from "./wage.vue?vue&type=template&id=df882c5e&"
import script from "./wage.vue?vue&type=script&lang=js&"
export * from "./wage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports